import {getExternalUrlIntent, DBXStandardIntents} from '#core/utils/intent-factory.js';

import {ApplicationConfig} from '#core/config/application-config.js';

class INTENT extends DBXStandardIntents {
    init() {
        super.init();
        const {customLinks: {footer = {}} = {}} = ApplicationConfig.config;

        this.FOOTER =
            CLIENT_NAME === 'sportium-es'
                ? {}
                : {
                      ABOUT_US: getExternalUrlIntent(footer.aboutUs, '$APPLICATION_FOOTER.ABOUT_US'),
                      CONCESSION_AGREEMENT: getExternalUrlIntent(
                          footer.concessionAgreement,
                          '$APPLICATION_FOOTER.CONCESSION_AGREEMENT'
                      ),
                      FIND_OUR_STORIES: getExternalUrlIntent(
                          footer.findOurStories,
                          '$APPLICATION_FOOTER.FIND_OUR_STORIES'
                      ),
                      AYUDA: getExternalUrlIntent(footer.ayuda),
                      CONTACT_US: getExternalUrlIntent(footer.contactUs, '$APPLICATION_FOOTER.CONTACT_US'),
                      PAYMENT_METHODS: getExternalUrlIntent(
                          footer.paymentMethods,
                          '$APPLICATION_FOOTER.PAYMENT_METHODS'
                      ),
                      FAQ: getExternalUrlIntent(footer.faq, '$APPLICATION_FOOTER.FAQ'),
                      CLAIMS_RESOLUTION: getExternalUrlIntent(
                          footer.claimResolution,
                          '$APPLICATION_FOOTER.CLAIMS_RESOLUTION'
                      ),
                      AFFILIATES: getExternalUrlIntent(footer.affiliates, '$APPLICATION_FOOTER.WANT_TO_AFFILIATE'),
                      SPORT_BET: getExternalUrlIntent(footer.sportBet, '$APPLICATION_FOOTER.SPORT_BET'),
                      NORMANS_LIVE: getExternalUrlIntent(footer.liveStadtard, '$APPLICATION_FOOTER.LIVE_STADTARDS'),
                      CASINO: getExternalUrlIntent(footer.casino, '$APPLICATION_FOOTER.CASINO'),
                      RESPONSIBLE_GAMBLING: getExternalUrlIntent(
                          footer.responsibleGambling,
                          '$APPLICATION_FOOTER.RESPONSIBLE_GAMBLING'
                      ),
                      TERMS_AND_CONDITIONS: getExternalUrlIntent(
                          footer.termsAndConditions,
                          '$APPLICATION_FOOTER.TERMS_AND_CONDITIONS'
                      ),
                      PRIVACY_POLICY: getExternalUrlIntent(footer.privacyPolicy, '$APPLICATION_FOOTER.PRIVACY_POLICY'),
                      COOKIE_POLICY: getExternalUrlIntent(footer.cookiesPolicy, '$APPLICATION_FOOTER.COOKIE_POLICY'),
                      SYSTEM_REQUIREMENTS: getExternalUrlIntent(
                          footer.systemRequirements,
                          '$APPLICATION_FOOTER.SYSTEM_REQUIREMENTS'
                      ),
                      CANAL_LINEA: getExternalUrlIntent(footer.canalLinea, '$APPLICATION_FOOTER.CANAL_LINEA'),
                      TERMS_AND_CONDITIONS_ALT: getExternalUrlIntent(
                          footer.termsAndConditionsAlt,
                          '$APPLICATION_FOOTER.TERMS_AND_CONDITIONS_ALT_1'
                      ),
                      POWER_BY_PBS: getExternalUrlIntent(footer.powerByPbs),
                      COLJUEGOS: getExternalUrlIntent(footer.coljuegos),
                      JUEGABIEN: getExternalUrlIntent(footer.juegabien),
                      YOUTUBE: getExternalUrlIntent(footer.youtube),
                      INSTAGRAM: getExternalUrlIntent(footer.instagram),
                      HELP: getExternalUrlIntent(footer.help),
                  };
    }
}

export default new INTENT();
